import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';

export const FilledCircle = Styled(
	createSvgIcon(
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<circle cx='12' cy='12' r='7.5' stroke='#D3D3D4' />
			<circle cx='12' cy='12' r='5' fill='currentColor' />
		</svg>,
		'FilledCircle'
	)
);

export default FilledCircle;
